import styled, { css } from 'styled-components'

import { CurrencyIcon } from '@root/entities/currency/ui'
import { useTranslation } from '@root/shared/localization'
import { Input } from '@root/shared/ui-kit'

import type { CurrencyModel } from '@root/entities/currency'

type Props = {
  currency: CurrencyModel
  value: string
  onChange: (value: string) => void
}

export const InstantTradeSwapInput: React.FC<Props> = ({
  currency,
  onChange,
  value,
}) => {
  const { t } = useTranslation()
  return (
    <AmountInput
      numeric
      startContent={
        <span
          css={css`
            font-weight: 400;
          `}
        >
          {t('common.amount')}
        </span>
      }
      decimalScale={currency.decimals}
      onChange={(e) => onChange(e.target.value)}
      value={value}
      size="m"
      endContent={
        <CurrencyIcon
          currency={currency}
          size={24}
          withGoogleLens={false}
          css={css`
            justify-self: end;
          `}
        />
      }
    />
  )
}

const AmountInput = styled(Input)`
  --input-height: 37px;
  --input-padding-inline: 10px 6px;
`
